import { useNavigate } from "react-router";
import SimpleFrame from "../../components/simple";
import styles from './styles.module.css';

function SettingsEndPage() {
  const navigation = useNavigate();
  const goHome = () => {
    navigation('/');
  }

  return (
    <div className={styles.settingsEnd}>
        <div className={styles.backgroundContainer}>
          <img src="/images/succes-background.png" alt=""/>
        </div>
        <SimpleFrame title="Готово" subtitle={"Включайте и выключайте VPN \n в приложении"} buttonLabel="Завершить настройку" handleClick={() => goHome()}></SimpleFrame>
    </div>
  );
}

export default SettingsEndPage;